/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/student.scss';
import Tab from '../../component/Inc/Tab';
import Paging from '../../component/Inc/Paging';
import Modal from '../../component/Inc/Modal';
import PopFinishClassPlan from './_PopFinishClassPlan';
function FinishClassPlan() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '국어', value: 0},
    {title: '영어', value: 1},
    {title: '수학', value: 2},
    {title: '과탐', value: 3},
    {title: '사탐', value: 4},
    {title: '논술', value: 5},
    {title: '면접', value: 6},
    {title: '생디', value: 7},
    {title: '미작성', type: ' red', value: 8},
    {title: '내 계획서', value: 9}
  ];
  const [modalFinishClassPlan, setModalFinishClassPlan] = useState(false);
  const [modalDate, setModalDate] = useState(false);

  return (
    <main className="com_container p_finish_class_plan">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_20">마무리 수업계획서</h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalDate(true)} className="com_btn gray s">
              수능일 입력
            </button>
            <button onClick={() => setModalFinishClassPlan(true)} className="com_btn orange s btn_plus">
              마무리 수업계획서 등록
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="4%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>등록일</th>
                  <th>마지막 수업 예정일</th>
                  <th>등록자 (교사)</th>
                  <th>학생명</th>
                  <th>과목</th>
                  <th>내용</th>
                  <th>담임</th>
                  <th>비고</th>
                  <th>담임 보고서</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>11</td>
                  <td className="td_date td_red">미등록</td>
                  <td className="td_date">2022.08.25</td>
                  <td>
                    <button className="btn_link">가교사102</button>
                  </td>
                  <td>
                    <button className="btn_link">가학생102</button>
                  </td>
                  <td>수학</td>
                  <td className="td_point">타임추가 11회</td>
                  <td>
                    <button className="btn_link">가담임102</button>
                  </td>
                  <td>
                    <button className="btn_link red">미작성</button>
                  </td>
                  <td>
                    <button className="btn_link red">미작성</button>
                  </td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{10 - idx}</td>
                      <td className="td_date">2022.08.25</td>
                      <td className="td_date">2022.08.25 06:30</td>
                      <td>
                        <button className="btn_link">가교사102</button>
                      </td>
                      <td>
                        <button className="btn_link">가학생102</button>
                      </td>
                      <td>수학</td>
                      <td className="td_point">타임추가 11회</td>
                      <td>
                        <button className="btn_link">가담임102</button>
                      </td>
                      <td>
                        <button className="btn_link blue">2023, 05, 10</button>
                      </td>
                      <td>
                        <button className="btn_link blue">2023, 05, 10</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 상세보기 */}
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <div className="count">
                <button className="com_icon darkGray">타임 추가</button>
                <button className="btn_edit" />
              </div>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <button className="name btn_link">홍길동103 </button>
                    (고3ㆍ경기고등학교ㆍ본사)
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info type_row">
                  <span className="tit">과목</span>
                  <div className="cont">
                    <p className="txt">국어 | 2T</p>
                  </div>
                  <span className="tit">수업진행</span>
                  <div className="cont">
                    <p className="txt">10/35 회차 진행중</p>
                  </div>
                </div>
                <div className="info type_row">
                  <span className="tit">과목</span>
                  <div className="cont">
                    <p className="txt com_blue_txt">국어</p>
                  </div>
                  <span className="tit">담임</span>
                  <div className="cont">
                    <p className="txt com_blue_txt">김담임898</p>
                  </div>
                </div>
              </div>
              <div className="board_item">
                <div className="refund">
                  <div className="info">
                    <span className="cont">
                      기준일 : <span className="bold"> 2023. 05. 10</span>
                    </span>
                  </div>
                  <hr className="com_divider" />
                  <div className="com_input_wrap flex_between">
                    <input type="text" className="input xs" defaultValue={`34`} />
                    <span className="calc_txt">회 이후</span>
                    <input type="text" className="input xs" defaultValue={`11`} />
                    <span className="calc_txt">더 진행하여</span>
                    <input type="text" className="input xs" defaultValue={`45`} />
                    <span className="calc_txt">회로 종료</span>
                  </div>
                  <hr className="com_divider" />
                  <span className="cont">
                    추가 입금 예정액 :{' '}
                    <span className="bold">
                      150,000 X 11 = <span className="com_blue_txt">1650,00</span>
                    </span>
                  </span>
                </div>
              </div>
              <div className="board_item">
                <div className="cont">
                  <p className="name">학습계획</p>
                  <ul className="list">
                    <li className="item">1. 기출수능 분석을 통한 문제푸는 방법 확인</li>
                    <li className="item">2. EBS 출제 가능한 문학 작품 정리</li>
                    <li className="item">3. 비문학 구조, 문학 중요 개념 등 정리</li>
                  </ul>
                </div>
                <hr className="com_divider" />
                <div className="cont">
                  <p className="name">과제물</p>
                  <ul className="list">
                    <li className="item">1. 기출수능 분석을 통한 문제푸는 방법 확인</li>
                    <li className="item">2. EBS 출제 가능한 문학 작품 정리</li>
                    <li className="item">3. 비문학 구조, 문학 중요 개념 등 정리</li>
                  </ul>
                </div>
                <hr className="com_divider" />
                <div className="cont">
                  <p className="name">학습목표</p>
                  <ul className="list">
                    <li className="item">1. 기출수능 분석을 통한 문제푸는 방법 확인</li>
                    <li className="item">2. EBS 출제 가능한 문학 작품 정리</li>
                    <li className="item">3. 비문학 구조, 문학 중요 개념 등 정리</li>
                  </ul>
                </div>
                <hr className="com_divider" />
                <div className="cont">
                  <p className="name">취약단원</p>
                  <ul className="list">
                    <li className="item">1. 기출수능 분석을 통한 문제푸는 방법 확인</li>
                    <li className="item">2. EBS 출제 가능한 문학 작품 정리</li>
                    <li className="item">3. 비문학 구조, 문학 중요 개념 등 정리</li>
                  </ul>
                </div>
              </div>
              <div className="board_item">
                <div className="refund">
                  <div className="info">
                    <span className="cont">
                      <button className="name btn_link">홍길동103 </button>
                      (고3ㆍ경기고등학교ㆍ본사)
                    </span>
                    <div className="btn_wrap">
                      <button className="com_icon darkGray">타임 추가</button>
                      <button className="btn_edit" />
                    </div>
                  </div>
                  <hr className="com_divider" />
                  <div className="com_input_wrap flex_between">
                    <input type="text" className="input xs" defaultValue={`34`} />
                    <span className="calc_txt">회 이후</span>
                    <input type="text" className="input xs" defaultValue={`11`} />
                    <span className="calc_txt">더 진행하여</span>
                    <input type="text" className="input xs" defaultValue={`45`} />
                    <span className="calc_txt">회로 종료</span>
                  </div>
                  <hr className="com_divider" />
                  <span className="cont">최종 45회로 종료 입니다</span>
                  <hr className="com_divider" />
                  <div className="info">
                    <span className="tit">입금 방법</span>
                    <div className="cont">무통장 입금</div>
                  </div>
                  <div className="info">
                    <span className="tit">입금자 명</span>
                    <div className="cont">홍길동</div>
                  </div>
                  <div className="info">
                    <span className="tit">입금일</span>
                    <div className="cont">2023. 05, 06 06:30</div>
                  </div>
                  <div className="info">
                    <span className="tit">계좌번호</span>
                    <div className="cont">123456789</div>
                  </div>
                  <div className="info">
                    <span className="tit">입금액</span>
                    <div className="cont">
                      150,000 X 11 = <span className="bold com_blue_txt">1650,000</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>
      <PopFinishClassPlan open={modalFinishClassPlan} close={() => setModalFinishClassPlan(false)} />
      <Modal open={modalDate} close={() => setModalDate(false)} type="type_alert" popSize="s">
        <h2 className="pop_tit">수능일 입력</h2>
        <div className="content_container">
          <div className="com_calendar_wrap">
            <div className="year">
              <button className="btn btn_prev"></button>
              <button className="btn_txt">2023</button>
              <button className="btn btn_next"></button>
            </div>
          </div>
          <div className="com_input_wrap flex_row">
            <input type="text" className="input" placeholder="월" defaultValue={`12월`} />
            <input type="text" className="input" placeholder="일" defaultValue={`11월`} />
          </div>
        </div>
        <div className="btn_container">
          <button className="com_btn orange xs">저장</button>
        </div>
      </Modal>
    </main>
  );
}

export default FinishClassPlan;
